import { isPromoInDateRange } from '@/config/promo';
import type { PromoConfig } from '@/types/promo';

interface ActivePromoResponse {
  promo?: PromoConfig | null;
}

const ACTIVE_PROMO_FUNCTION_PATH = '/.netlify/functions/active-promo';

function isPromoShape(value: unknown): value is PromoConfig {
  if (!value || typeof value !== 'object') return false;

  const maybePromo = value as PromoConfig;
  return Boolean(maybePromo.code && maybePromo.startDate && maybePromo.endDate);
}

function normalizePromo(value: unknown): PromoConfig | null {
  if (!isPromoShape(value)) return null;
  if (!isPromoInDateRange(value)) return null;
  return value;
}

export async function fetchRuntimeActivePromo(): Promise<PromoConfig | null> {
  if (typeof window === 'undefined') return null;

  try {
    const response = await fetch(ACTIVE_PROMO_FUNCTION_PATH, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Active promo request failed: ${response.status}`);
    }

    const payload = (await response.json()) as ActivePromoResponse;
    const runtimePromo = normalizePromo(payload?.promo);
    if (runtimePromo) return runtimePromo;
  } catch {
    // Intentionally ignored: no fallback source, promo is disabled on incidents.
  }

  return null;
}
